import { Map as map } from 'immutable';
import update from "react-addons-update";
const C = require("../constants");

function SimpleTableDataReducer(state = map(), action) {
    let results = null;
    switch (action.type) {
        case C.SIMPLE_TABLE_LIST:
            return action.data;
        case C.SIMPLE_TABLE_LIST_ADD_OR_UPDATE:
            results = state.data.slice();
            if (results.some(res => res.id === action.data.id)){
                results = results.map(data => {
                    data = action.data.id === data.id ? action.data:data;
                    return data
                });
                return update(state, { data: {$set: results} });
            }else{
                results.unshift(action.data);
                return update(state, {data: {$set: results}});
            }
        case C.SIMPLE_TABLE_LIST_DELETE:
            results = state.data.slice();
            results = results.filter(data => {
                return data.id !== action.data;
            });
            return update(state, {data: {$set: results}});
        default:
            return state;
    }
}

export default SimpleTableDataReducer;


// WEBPACK FOOTER //
// ./src/reducers/SimpleTableDataReducer.js